// export enum LANGUAGE_CODES {
// 	EN_GB = 'en-gb', //this is an exception for dayjs
// 	EN = 'en',
// 	IT = 'it',
// 	ES = 'es',
// 	DE = 'de',
// }

// export const LANGUAGES = [
// 	{ id: 'en-gb', label: 'English (UK)', localeDayjs: LANGUAGE_CODES.EN_GB },
// 	{ id: 'en-us', label: 'English (US)', localeDayjs: LANGUAGE_CODES.EN },
// 	{ id: 'it-it', label: 'Italiano', localeDayjs: LANGUAGE_CODES.IT },
// 	{ id: 'es-es', label: `Espa\u00f1ol`, localeDayjs: LANGUAGE_CODES.ES },
// 	{ id: 'de-de', label: 'Deutsch', localeDayjs: LANGUAGE_CODES.DE },
// ];

import TRANSLATION_EN_CLIENT from '../locales/clientLabels/en.json';
import TRANSLATION_IT_CLIENT from '../locales/clientLabels/it.json';
import TRANSLATION_ES_CLIENT from '../locales/clientLabels/es.json';
import TRANSLATION_DE_CLIENT from '../locales/clientLabels/de.json';
import TRANSLATION_EN_DB from '../locales/dbLabels/en.json';
import TRANSLATION_IT_DB from '../locales/dbLabels/it.json';
import TRANSLATION_ES_DB from '../locales/dbLabels/es.json';
import TRANSLATION_DE_DB from '../locales/dbLabels/de.json';
import TRANSLATION_EN_ERRORS from '../locales/errors/en.json';
import TRANSLATION_IT_ERRORS from '../locales/errors/it.json';
import TRANSLATION_ES_ERRORS from '../locales/errors/es.json';
import TRANSLATION_DE_ERRORS from '../locales/errors/de.json';

export enum LANGUAGE_CODES {
	EN_GB = 'en-gb', //this is an exception for dayjs
	EN = 'en',
	IT = 'it',
	ES = 'es',
	DE = 'de',
}

export const LANGUAGES = [
	{ id: 'en-gb', label: 'English UK', localeDayjs: LANGUAGE_CODES.EN_GB },
	{ id: 'en-us', label: 'English US', localeDayjs: LANGUAGE_CODES.EN },
	{ id: 'it-it', label: 'Italian', localeDayjs: LANGUAGE_CODES.IT },
	{ id: 'es-es', label: 'Spanish', localeDayjs: LANGUAGE_CODES.ES },
	{ id: 'de-de', label: 'German', localeDayjs: LANGUAGE_CODES.DE },
];

export const DEFAULT_LANGUAGE = {
	[LANGUAGE_CODES.EN]: {
		translation: {
			clientLabels: TRANSLATION_EN_CLIENT,
			dbLabels: TRANSLATION_EN_DB,
			errors: TRANSLATION_EN_ERRORS,
		},
	},
	[LANGUAGE_CODES.IT]: {
		translation: {
			clientLabels: TRANSLATION_IT_CLIENT,
			dbLabels: TRANSLATION_IT_DB,
			errors: TRANSLATION_IT_ERRORS,
		},
	},
	[LANGUAGE_CODES.ES]: {
		translation: {
			clientLabels: TRANSLATION_ES_CLIENT,
			dbLabels: TRANSLATION_ES_DB,
			errors: TRANSLATION_ES_ERRORS,
		},
	},
	[LANGUAGE_CODES.DE]: {
		translation: {
			clientLabels: TRANSLATION_DE_CLIENT,
			dbLabels: TRANSLATION_DE_DB,
			errors: TRANSLATION_DE_ERRORS,
		},
	},
};
